import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { navigateInShell, navigateRoot } from '../../shell/navigation/rootNavigation';

export type OrganizationIdentityRouteParams = {
  focusSection?: 'logo';
};

export type OrganizationIdentityNavigationContext = 'hub' | 'shell';

export function navigateToOrganizationIdentity(
  navigation: NavigationProp<ParamListBase>,
  context: OrganizationIdentityNavigationContext,
  params: OrganizationIdentityRouteParams = { focusSection: 'logo' },
): void {
  if (context === 'hub') {
    navigateRoot(navigation, 'HubOrganization', params);
    return;
  }
  navigateInShell(navigation, 'Organization', params);
}
